export default "__VITE_ASSET__CboM9sfB__"